import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
export const SingleResponseQuestionWidgetServerModelHelper = {
    createOption: (option) => ({
        text: option.text,
        isCorrect: option.isCorrect,
    }),
    isQuestionWidgetServerModel: (widgetServerModel) => {
        return widgetServerModel.type === WidgetType.question;
    },
};
